import { TextField } from '@mui/material';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';
import React from 'react';

const useStyles = makeStyles((theme) => ({
	error: {
		border: `1px solid ${theme.palette.error[700]}`,
		'& input::placeholder': {
			color: `${theme.palette.error[700]} !important`,
		},
	},
	primary: {
		margin: '0',
		paddingLeft: '0',
		'& input::placeholder': {
			color: theme.palette.text.secondary,
		},
		borderRadius: theme.shape.borderRadius,
		'&.Mui-focused': {
			'& svg': {
				stroke: theme.palette.primary.dark,
			},
		},
		'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
			border: 'none !important',
			boxShadow: '0px 24px 40px -8px rgba(0, 0, 0, 0.06)',
		},
	},
	secondary: {
		backgroundColor: theme.palette.background.light,
	},
	meduStyle: {
		backgroundColor: theme.palette.background.light,
		border: `1px solid ${theme.palette.primary[300]} !important`,
	},
	MuiInputAdornment: {
		'& svg': {
			width: '1.8rem',
			height: '1.8rem',
			transition: 'all .3s',
		},
	},
	MuiInputLabel: {
		border: 'none',
		// padding: '0 .8rem',
		'& label': {
			'&::after': {
				content: (props) => (props.required ? '"*"' : '""'),
				fontSize: '2rem',
			},
		},
		'& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
			transform: 'translate(9px, -6px) scale(0.75)',
		},
		'& .MuiSelect-select': {
			height: '0px',
		},
	},
	third: {
		backgroundColor: theme.palette.background.light,
		// border: `1px solid ${theme.palette.primary[300]} !important`
		'& svg': {
			color: `${theme.palette.text.secondary} !important`,
		},
		'&.Mui-focused ': {
			border: `1px solid #EFC800 !important`,
			boxShadow: `0px 0px 0px 4px ${theme.palette.secondary[300]} !important`,
			caretColor: theme.palette.secondary[700],
			'& svg': {
				color: `#EFC800 !important`,
			},
		},
		'& .MuiOutlinedInput-notchedOutline': {
			border: `1px solid ${theme.palette.primary[300]} !important`,
		},

		'& .MuiOutlinedInput-root:hover ': {
			border: `1px solid ${theme.palette.primary[300]} !important`,

			'& .MuiOutlinedInput-notchedOutline': {
				border: `1px solid ${theme.palette.primary[300]} !important`,
			},
		},
	},
	MuiSelectSelect: {},
}));

const InputKit = (props) => {
	const { InputProps, textarea, secondary, ...rest } = props;
	const classes = useStyles({ required: props.required });

	return (
		<TextField
			classes={{ root: classes.MuiInputLabel }}
			InputProps={{
				classes: {
					error: classes.error,
					root: clsx({
						[classes.secondary]: secondary,
						[classes.primary]: !secondary,
						[classes.third]: rest.third,
						[classes.meduStyle]: rest.meduStyle,
					}),
					adornedStart: classes.MuiInputAdornment,
					...InputProps?.classes,
				},

				...InputProps,
			}}
			multiline={textarea}
			rows={textarea ? 4 : undefined}
			{...rest}
		/>
	);
};

export default InputKit;

InputKit.defaultProps = {
	variant: 'outlined',
	size: 'medium',
	fullWidth: true,
	textarea: false,
};

InputKit.displayName = 'InputKit';
